import { getImagePreloadCandidates } from "../components/imageMeta";

export const CHECKOUT_HERO_IMAGE_URL = "/checkout.webp";

export const CHECKOUT_FEATURE_IMAGE_URLS = {
  dailyDrops: "/features_cards.webp",
  curiosityHabit: "/features_habbit.webp",
  personalized: "/features_map.webp",
  rewarding: "/features_cozy_2.webp"
} as const;

const CHECKOUT_IMAGE_URLS = [CHECKOUT_HERO_IMAGE_URL, ...Object.values(CHECKOUT_FEATURE_IMAGE_URLS)];

export const getCheckoutImagePreloadUrls = (): string[] => {
  const uniqueUrls = new Set<string>();

  for (const imageUrl of CHECKOUT_IMAGE_URLS) {
    const candidates = getImagePreloadCandidates(imageUrl);
    for (const candidate of candidates) {
      uniqueUrls.add(candidate);
    }
  }

  return Array.from(uniqueUrls);
};
